import { render } from "./ZeroMalariaLayout.vue?vue&type=template&id=4d9c3944"
import script from "./ZeroMalariaLayout.vue?vue&type=script&lang=js"
export * from "./ZeroMalariaLayout.vue?vue&type=script&lang=js"

import "./ZeroMalariaLayout.vue?vue&type=style&index=0&id=4d9c3944&lang=scss"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__